import {observer} from 'mobx-react-lite'
import * as React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Checklist} from 'yougile-model'
import {TextArea} from '@components/common/base/textarea'
import {useChecklistStore} from './checklist-store'
import {LinkSmall} from './link-small'

type Props = {
  list: Checklist
}

const TwContainer = tw.div`
  p-8
  bg-grey-l80
  rounded-4

  cursor-default
  text-sm-regular
  text-primary
  relative
`

const TwContent = tw.div`
  w-full
`

const TwButtonsContainer = tw.div`
  flex
  gap-16
  items-center
  justify-start
  ml-24
`
const TwBorder = tw.div`
  w-auto
  ml-24
  mt-8
  pt-8

  shadow-border-t-1
  shadow-grey-l60
`

export const ChecklistTitleEdit = observer(({list}: Props) => {
  const [state, store] = useChecklistStore()

  return (
    <TwContainer>
      <TwContent>
        <TextArea
          className="w-full"
          icon="IconListCheck"
          iconPosition="left"
          defaultValue={state.unsavedTitle || list.title}
          onSubmit={store.submitEditTitle}
          onChange={store.onChangeTitle}
          onCancel={store.cancelEditTitle}
          onBlur={store.blurEditTitle}
          autoFocus
          borders={false}
          paddings={'none'}
          noBackground
        />
      </TwContent>

      <TwBorder />

      <TwButtonsContainer>
        <LinkSmall color="primary" onMouseDown={store.submitEditTitle}>
          {Lang.msg.save}
        </LinkSmall>
        <LinkSmall color="error" onMouseDown={store.cancelEditTitle}>
          {Lang.msg.cancel}
        </LinkSmall>
        <LinkSmall color="error" onMouseDown={store.delete} className="ml-auto">
          {Lang.msg.checklistDel}
        </LinkSmall>
      </TwButtonsContainer>
    </TwContainer>
  )
})
